export default theme => ({
  centered: {
    textAlign: 'center',
  },
  buttonBreaktime: {
    display: 'block',
    textTransform: 'none',
    width: '40%',
    margin: 'auto',
    marginTop: '1rem',
  },
})



// WEBPACK FOOTER //
// ./src/components/BreakPrompt/BreakPrompt.styles.js